import { render, staticRenderFns } from "./tambahupt.vue?vue&type=template&id=0c22d628&"
import script from "./tambahupt.vue?vue&type=script&lang=js&"
export * from "./tambahupt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports